import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { MvdModalService } from 'app/shared/services/modal/mvd-modal.service';
import { filter } from 'rxjs/operators';
import { FinanceSharedService } from '../../../../finance/shared/services/finance-shared.service';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { ModalSize } from '../../../../shared/services/modal/mvd-modal.enum';
import { CashDrawerConfirmationModal } from './cashdrawer-confirmation-modal.component';

@Component({
    selector: 'cashdrawer-confirmation',
    template: ''
})

export class CashDrawerConfirmationComponent extends BaseComponent implements OnInit {

    // Event emitter to output a ValidationResult of type error to the containing component
    @Output() error = new EventEmitter();

    /** The page constructor
     * @param modal
     * @param viewContainerRef
     * @param financeService
     */
    constructor(public modalService: MvdModalService, public viewContainerRef: ViewContainerRef, public financeService: FinanceSharedService) {
        super();
    }

    /**
     * Handles the init event
     */
    ngOnInit() {
        this.checkCashDrawerVerified();
    }

    /**
     * Makes the API call to determine if a cash drawer must be confirmed.  If verification required calls the method to confirm with the user.
     */
    checkCashDrawerVerified() {

        this.financeService.checkCashDrawerVerified().subscribe(
            result => {
                this.displayCashDrawerVerifyModal(result);
            },
            error => {
                this.error.emit(error);
            }
        );
    }

    /**
     * Displays the cash drawer confirmation dialog if confirmation is required
     * @param result The CashDrawerConfirmation model result returned by the API
     */
    public displayCashDrawerVerifyModal(result: any) {

        if (result.confirmationRequired) {

            this.modalService.open(CashDrawerConfirmationModal, result, ModalSize.Small).afterClosed()
                .pipe(filter(result => !!result))
                .subscribe(
                    res => {
                        this.setCashDrawerVerified(res);
                    },
                    err => (
                        this.handleValidationResult(err)
                    )
                );
        } else if (result.alertMessage) {
            this.modalService.alert().title('Verify Cash Drawer').body(result.message).open();
        }
    }

    /**
     * Makes the API call to set the cash drawer as verified
     * @param cashDrawerVerificationData The the data returned by the cash drawer confirmation modal.
     */
    public setCashDrawerVerified(cashDrawerVerificationData: any) {
        this.financeService.setCashDrawerVerified(cashDrawerVerificationData).subscribe(
            res => { },
            error => {
                this.error.emit(error);
            }
        );
    }
}
